// extracted by mini-css-extract-plugin
export default {"children_banner_container":"ChildrenBanner_children_banner_container__lwHHp","children_banner_titile":"ChildrenBanner_children_banner_titile__+igAd"};